<template>
  <div class="intro">
    <!-- -->
    <div class="title">{{ $t('doc.intro_title') }}</div>
    <div>
      <p>
        {{ $t('doc.intro_p1') }}
      </p>
      <p>
        {{ $t('doc.intro_p2') }}
      </p>
      <p>
        {{ $t('doc.intro_p3') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenWebIntroduction",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
.intro {
  padding: 0 10px;
  .title {
    margin: 18px 0;
    font-size: 24px;
    font-weight: bold;
  }
  p{
    padding: 9px 0;
    line-height: 30px;
    // text-indent: 2em;
  }
}
</style>